<div class="ai-chat-button" 
  (click)="toggleChat()"
  oneTooltipPosition="bottom"
  [oneTooltipSkipUnderline]="true"
  [oneTooltip]="'Ask me anything'">
  <one-icon name="sparkles-sharp"></one-icon>
</div>
